export enum EmploymentClassification {
    No = 0,
    Volunteer = 1,
    PartTime = 2,
    FullTime = 3
}